<page-headline
    [linkTitle]="''"
    [module]="pageHeadline.module"
    [moduleIcon]="pageHeadline.moduleIcon"
    [moduleLink]="pageHeadline.moduleLink"
    [pageTitle]="pageHeadline.pageTitle"
    [linkArray]="pageHeadline.linkArray"
>
</page-headline>
<div style="display: flex; justify-content: space-between">
    <main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
</div>

<div style="display: flex; align-items: center">
    <display-options
        (displayOptionsOutput)="applyDisplayOptions($event)"
        [showCompareToDate]="false"
        [showRollingDateRange]="false"
        [hiddenFilterItems]="hiddenFilterItems"
        [asOfDateId]="asOfDateId"
    >
    </display-options>
    <div class="displayopt-layout" style="margin-top: -27px">
        <action-panel
            [showExportCsv]="false"
            [showSaveAsPdf]="true"
            [showPrint]="false"
            [title]="pageHeadline.pageTitle"
        >
        </action-panel>
    </div>
</div>
<div class="kendo-container">
    <div class="monthly-lo-grid-container vol-grid-container">
        <h4>Rankings by Volume Funded</h4>
        <kendo-grid
            class="lg-kendo-grid ranking-report-table lg-scrollbar monthly-lo-grid"
            [data]="volGridData"
            [pageable]="pageable"
            [pageSize]="pageSize"
            [skip]="skip.volSkip"
            [loading]="loading"
            [sort]="volSort"
            [sortable]="sortable"
            (sortChange)="sortChange($event, 'vol')"
            (pageChange)="pageChange($event, 'vol')"
        >
            <ng-template kendoGridNoRecordsTemplate>
                <div class="no-data-message-area" *ngIf="!loading && noData">
                    <no-data-screen [noDataType]="noDataType"></no-data-screen>
                </div>
            </ng-template>
            <kendo-grid-column
                field="ranked"
                title="Rank"
                [style]="{
                    width: '11%',
                    'text-align': 'right',
                }"
                [headerStyle]="{ width: '11%' }"
            >
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.ranked }}.
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                field="employee"
                title="Name"
                [style]="{ width: '18%' }"
                [headerStyle]="{ width: '18%' }"
            >
            </kendo-grid-column>
            <kendo-grid-column
                field="friendlyTenure"
                title="Tenure"
                [style]="{ width: '11%' }"
                [headerStyle]="{ width: '11%' }"
            >
            </kendo-grid-column>
            <kendo-grid-column
                field="mtdMeasure"
                title="MTD Volume"
                [style]="{ width: '20%', 'text-align': 'right' }"
                [headerStyle]="{ width: '19%', 'text-align': 'right' }"
            >
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.mtdMeasure | currency : 'USD' : 'symbol' : '1.0-0' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                field="prevMTDChg"
                title="Prior MTD"
                [style]="{ width: '16%', 'text-align': 'right' }"
                [headerStyle]="{ width: '16%', 'text-align': 'right' }"
            >
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i
                        *ngIf="dataItem.prevMTDChg !== null"
                        class="fas"
                        [ngClass]="{
                            'fa-caret-down': dataItem.prevMTDChg < 0,
                            'fa-caret-up': dataItem.prevMTDChg > 0
                        }"
                        [style]="{
                            color: dataItem.prevMTDChg > 0 ? '#008800' : '#E0000E',
                            'padding-right': dataItem.prevMTDChg < 0 ? '8px' : '5px'
                        }"
                    ></i>
                    <span
                        [style]="{ color: dataItem.prevMTDChg > 0 ? '#008800' : '#E0000E' }"
                        *ngIf="dataItem.prevMTDChg !== null"
                        >{{ dataItem.prevMTDComp.comparison }}</span
                    >
                    <span *ngIf="dataItem.prevMTDChg === null">--</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                field="mtdMeasure"
                title="12 Month Trend"
                [style]="{ width: '37%', 'padding-right': '5px' }"
                [headerStyle]="{ width: '37%', 'padding-right': '5px' }"
                [sortable]="false"
            >
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div
                        id="volmtdMeasure{{ dataItem.employee }}"
                        class="revenue-trends-charts"
                    ></div>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="monthly-lo-grid-container unit-grid-container">
        <h4>Rankings by Units Funded</h4>
        <kendo-grid
            class="lg-kendo-grid ranking-report-table lg-scrollbar monthly-lo-grid"
            [data]="unitsGridData"
            [pageable]="pageable"
            [pageSize]="pageSize"
            [skip]="skip.unitSkip"
            [loading]="loading"
            [sort]="unitSort"
            [sortable]="sortable"
            (sortChange)="sortChange($event, 'unit')"
            (pageChange)="pageChange($event, 'unit')"
        >
            <ng-template kendoGridNoRecordsTemplate>
                <div class="no-data-message-area" *ngIf="!loading && noData">
                    <no-data-screen [noDataType]="noDataType"></no-data-screen>
                </div>
            </ng-template>
            <kendo-grid-column
                field="ranked"
                title="Rank"
                [style]="{
                    width: '11%',
                    'text-align': 'right',
                }"
                [headerStyle]="{ width: '11%' }"
            >
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.ranked }}.
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                field="employee"
                title="Name"
                [style]="{ width: '18%' }"
                [headerStyle]="{ width: '18%' }"
            >
            </kendo-grid-column>
            <kendo-grid-column
                field="friendlyTenure"
                title="Tenure"
                [style]="{ width: '12%' }"
                [headerStyle]="{ width: '12%' }"
            >
            </kendo-grid-column>
            <kendo-grid-column
                field="mtdMeasure"
                title="MTD Units"
                [style]="{ width: '16%', 'text-align': 'center' }"
                [headerStyle]="{ width: '16%', 'text-align': 'center' }"
            >
            </kendo-grid-column>
            <kendo-grid-column
                field="prevMTDChg"
                title="Prior MTD"
                [style]="{ width: '17%', 'text-align': 'right' }"
                [headerStyle]="{ width: '17%', 'text-align': 'right' }"
            >
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i
                        *ngIf="dataItem.prevMTDChg !== null"
                        class="fas"
                        [ngClass]="{
                            'fa-caret-down': dataItem.prevMTDChg < 0,
                            'fa-caret-up': dataItem.prevMTDChg > 0
                        }"
                        [style]="{
                            color: dataItem.prevMTDChg > 0 ? '#008800' : '#E0000E',
                            'padding-right': dataItem.prevMTDChg < 0 ? '8px' : '5px'
                        }"
                    ></i>
                    <span
                        [style]="{ color: dataItem.prevMTDChg > 0 ? '#008800' : '#E0000E' }"
                        *ngIf="dataItem.prevMTDChg !== null"
                        >{{ dataItem.prevMTDComp.comparison }}</span
                    >
                    <span *ngIf="dataItem.prevMTDChg === null">--</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                field="mtdMeasure"
                title="12 Month Trend"
                [style]="{ width: '37%', 'padding-right': '5px' }"
                [headerStyle]="{ width: '37%', 'padding-right': '5px' }"
                [sortable]="false"
            >
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div
                        id="unitmtdMeasure{{ dataItem.employee }}"
                        class="revenue-trends-charts"
                    ></div>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>
